// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  width: '100%',
  userSelect: 'none',
})

export const DayOfWeek = styled('div', {
  fontWeight: 400,
  fontSize: '14px',
  textAlign: 'center',
})

export const DowsRow = styled('div', {
  marginBottom: '10px',
})
